import React from 'react';
import * as S from './FavouritesList.styled';
import { useSelector } from 'react-redux';
import Table from './components/Table';
import { FavouritesListItemsSelector } from './FavouritesListSlice';

const FavouritesList: React.FC = () => {
  // Список избранных лотов
  const favourites = useSelector(FavouritesListItemsSelector);

  return (
    <S.Wrap>
      <Table items={favourites} />
    </S.Wrap>
  );
};

export default FavouritesList;
